var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#chat-gpt';
                    var viewUrl = 'svg/icons.svg#view-chat-gpt';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 671.194 680.249',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };